module.exports = __webpack_public_path__ + "clsuters_lineplots.png";